module.exports = __webpack_public_path__ + "img/ur3_banner.63fe1878.jpg";